import { TypePageBigData } from 'o2o_layout/lib/common/interface';
import { IResponseBigDataVN, TypeResultsBigData } from '../../../../../common/IResponseBigData';

export type TPlatformUserTermItem = {
  id: string;
  orgId: string;
  userId: string;
  term: string;
  active: boolean;
  updatedAt: number;
  updatedBy: string;
};

export type TCriteriaPlatformUserTermItem = {
  page?: number;
  pageSize?: number;
  userIds?: string;
};

export class ManagePlatformUserTerm implements IResponseBigDataVN<TPlatformUserTermItem> {
  results: TypeResultsBigData<TPlatformUserTermItem>;
  success: boolean;
  message?: string;
  constructor() {
    this.success = false;
    this.message = undefined;
    this.results = {
      content: [],
      currentTime: 0,
      extras: null,
      page: {
        pageSize: 0,
        currentPage: 0,
        totalRecords: 0,
        totalPages: 0,
      } as TypePageBigData,
      timeTaken: 0,
    };
  }
}
